import { cloneObject } from "../utils/utils";
import JSZip from "jszip";


export const addSolution = (dsd, Data = {}, onAdd, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let payload = payloadSolution(Data)

    dsd.httpConfig.post(`/solutions`, payload, headers)
        .then(response => {
            if (onAdd){
                onAdd(response.data._id)
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return;
}

export const editSolution = (dsd, id = null, Data = {}, onUpdate, onError) => {
    
    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }


    let payload = payloadSolution(Data)

    dsd.httpConfig.put(`/solutions/${id}`, payload, headers)
        .then(response => {
            if (onUpdate){
                onUpdate();
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return true;
};


function payloadSolution(data){

    let payload = {}
    payload.name = data.name;
    payload.description = data.description;
    payload.namespace = data.namespace;
    payload.prefix = data.prefix;
    payload.proposals = data.proposals;
    payload.status = data.status;

    return payload;

}


export const getSolution = (dsd, id=null, onLoad=null, onFail=null, representation="dsd", format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/solutions/${id}?`

        if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );

    return;

};


export const listSolutions = (dsd, Filters={}, onLoad, onError) => {
    
    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let urlAPI = "/solutions"
    if (Object.keys(Filters).length > 0){
        urlAPI += "?"
    }
    
    if (Filters.idUser){
        urlAPI += `idUser=${encodeURIComponent(Filters.idUser)}&`;
    }

    if (Filters.scope){
        urlAPI += `scope=${encodeURIComponent(Filters.scope)}&`;
    }

    if (Filters.status){
        urlAPI += `status=${encodeURIComponent(Filters.status)}&`;
    }

    if (Filters.search){
        urlAPI += `search=${encodeURIComponent(Filters.search)}&`;
    }
    
    dsd.httpConfig.get(urlAPI, headers)
        .then(response => {

            let arr = [];
            for (let pos=0; pos<response.data.length;pos++){
                arr.push(dataRole(response.data[pos]));
            }
            if (onLoad){
                onLoad(arr);
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return;

};

function dataSolution(data){

    let obj = data;

    return obj;

}


export const getSolutionVersion = (dsd, id=null, idVersion = null, onLoad=null, onFail=null, representation='dsd', format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/solutions/${id}/version/${idVersion}?`

    if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );

    return;

};


export const getSolutionVersionRoles = (dsd, id=null, idVersion = null, onLoad=null, onFail=null, representation='dsd', format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/solutions/${id}/version/${idVersion}/roles?`

    if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );

    return;

};

export const getSolutionVersionSystems = (dsd, id=null, idVersion = null, onLoad=null, onFail=null, representation='dsd', format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/solutions/${id}/version/${idVersion}/systems?`

    if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );

    return;

};


export const getSolutionVersionCapabilities = (dsd, id=null, idVersion = null, onLoad=null, onFail=null, representation='dsd', format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/solutions/${id}/version/${idVersion}/capabilities?`

    if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );

    return;

};


export const getSolutionVersionParticipations = (dsd, id=null, idVersion = null, onLoad=null, onFail=null, representation='dsd', format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/solutions/${id}/version/${idVersion}/participations?`

    if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );

    return;

};

// ==== Roles ====

export const addRoleToSolution = (dsd, idSolution, Data = {}, onAdd, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let payload = payloadRole(Data)

    dsd.httpConfig.post(`/solutions/${idSolution}/roles`, payload, headers)
        .then(response => {
            if (onAdd){
                onAdd(response.data._id)
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return;
}

export const editRole = (dsd, id = null, Data = {}, onUpdate, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }


    let payload = payloadRole(Data)
    let idSolution = null;
    if (Data.Solution) {
        idSolution = Data.Solution._id;
    }

    dsd.httpConfig.put(`/solutions/${idSolution}/roles/${id}`, payload, headers)
        .then(response => {
            if (onUpdate){
                onUpdate();
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });


    return true;
};

function payloadRole(inData){

    let data = cloneObject(inData)

    let payload = {}
    payload.name = data.name;
    payload.description = data.description;
    payload.proposals = data.proposals;
    payload.type = data.type;
    payload.status = data.status;
    payload.idSpecialises = data.idSpecialises || null;

    return payload;

}

export const getRole = (dsd, id=null, onLoad=null, onFail=null, representation="dsd", format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/roles/${id}?`

        if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );

    return;

};


export const listRoles = (dsd, Filters={}, onLoad, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let urlAPI = "/roles"
    if (Object.keys(Filters).length > 0){
        urlAPI += "?"
    }
    
    if (Filters.idUser){
        urlAPI += `idUser=${encodeURIComponent(Filters.idUser)}&`;
    }

    if (Filters.status){
        urlAPI += `status=${encodeURIComponent(Filters.status)}&`;
    }

    if (Filters.type){
        urlAPI += `type=${encodeURIComponent(Filters.type)}&`;
    }

    if (Filters.idSolution){
        urlAPI += `idSolution=${encodeURIComponent(Filters.idSolution)}&`;
    }

    if (Filters.idNarrative){
        urlAPI += `idNarrative=${encodeURIComponent(Filters.idNarrative)}&`;
    }


    dsd.httpConfig.get(urlAPI, headers)
        .then(response => {

            let arr = [];
            for (let pos=0; pos<response.data.length;pos++){
                arr.push(dataRole(response.data[pos]));
            }

            if (onLoad){
                onLoad(arr);
            }

        })
        .catch(e => {
            if (onError){
                onError(e);
            }
        });

    return;

};



function dataRole(data){

    let obj = data;

    return obj;

}



// ==== Systems ====

export const addSystemToSolution = (dsd, idSolution, Data = {}, onAdd, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let payload = payloadSystem(Data)

    dsd.httpConfig.post(`/solutions/${idSolution}/systems`, payload, headers)
        .then(response => {
            if (onAdd){
                onAdd(response.data._id)
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return;
}

export const editSystem = (dsd, id = null, Data = {}, onUpdate, onError) => {


    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }


    let payload = payloadSystem(Data)
    let idSolution = null;
    if (Data.Solution) {
        idSolution = Data.Solution._id;
    }

    dsd.httpConfig.put(`/solutions/${idSolution}/systems/${id}`, payload, headers)
        .then(response => {
            if (onUpdate){
                onUpdate();
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return true;
};

function payloadSystem(inData){

    let data = cloneObject(inData)

    let payload = {}
    payload.name = data.name;
    payload.description = data.description;
    payload.proposals = data.proposals;
    payload.status = data.status;

    return payload;

}

export const getSystem = (dsd, id=null, onLoad=null, onFail=null, representation="dsd", format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/systems/${id}?`

        if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );

    return;

};


export const listSystems = (dsd, Filters={}, onLoad, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let urlAPI = "/systems"
    if (Object.keys(Filters).length > 0){
        urlAPI += "?"
    }
    
    if (Filters.idUser){
        urlAPI += `idUser=${encodeURIComponent(Filters.idUser)}&`;
    }

    if (Filters.status){
        urlAPI += `status=${encodeURIComponent(Filters.status)}&`;
    }

    if (Filters.idSolution){
        urlAPI += `idSolution=${encodeURIComponent(Filters.idSolution)}&`;
    }

    if (Filters.idNarrative){
        urlAPI += `idNarrative=${encodeURIComponent(Filters.idNarrative)}&`;
    }


    dsd.httpConfig.get(urlAPI, headers)
        .then(response => {

            let arr = [];
            for (let pos=0; pos<response.data.length;pos++){
                arr.push(dataSystem(response.data[pos]));
            }

            if (onLoad){
                onLoad(arr);
            }

        })
        .catch(e => {
            if (onError){
                onError(e);
            }
        });

    return;

};

function dataSystem(data){

    let obj = data;

    return obj;

}



// ==== Capabilities ====

export const addCapabilityToSolution = (dsd, idSolution, Data = {}, onAdd, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let payload = payloadCapability(Data)

    dsd.httpConfig.post(`/solutions/${idSolution}/capabilities`, payload, headers)
        .then(response => {
            if (onAdd){
                onAdd(response.data._id)
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return;
}

export const editCapability = (dsd, id = null, Data = {}, onUpdate, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }


    let payload = payloadCapability(Data)
    let idSolution = null;
    if (Data.Solution) {
        idSolution = Data.Solution._id;
    }

    dsd.httpConfig.put(`/solutions/${idSolution}/capabilities/${id}`, payload, headers)
        .then(response => {
            if (onUpdate){
                onUpdate();
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return true;
};

function payloadCapability(inData){

    let payload = {}
    payload.name = inData.name;
    payload.description = inData.description;
    payload.proposals = inData.proposals;

    payload.precondition = inData.precondition;
    payload.postcondition = inData.postcondition;

    if (inData.type){
        payload.type = inData.type;
    }

    if (inData.idSystem){
        payload.idSystem = inData.idSystem;
    }

    if (inData.idCapabilityGroup){
        payload.idCapabilityGroup = inData.idCapabilityGroup;
    }


    payload.status = inData.status;

    if (inData.Dependencies){
        // Filter out empty dependencies (those without idCapability)
        payload.Dependencies = inData.Dependencies.filter(dep => dep.idCapability);
    }

    return payload;

}

export const getCapability = (dsd, id=null, onLoad=null, onFail=null, representation="dsd", format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/capabilities/${id}?`

        if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );

    return;

};


export const listCapabilities = (dsd, Filters={}, onLoad, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let urlAPI = "/capabilities"
    if (Object.keys(Filters).length > 0){
        urlAPI += "?"
    }
    
    if (Filters.idUser){
        urlAPI += `idUser=${encodeURIComponent(Filters.idUser)}&`;
    }

    if (Filters.status){
        urlAPI += `status=${encodeURIComponent(Filters.status)}&`;
    }

    if (Filters.idSolution){
        urlAPI += `idSolution=${encodeURIComponent(Filters.idSolution)}&`;
    }

    if (Filters.idSystem){
        urlAPI += `idSystem=${encodeURIComponent(Filters.idSystem)}&`;
    }


    if (Filters.idNarrative){
        urlAPI += `idNarrative=${encodeURIComponent(Filters.idNarrative)}&`;
    }

    if (Filters.type){
        urlAPI += `type=${encodeURIComponent(Filters.type)}&`;
    }


    dsd.httpConfig.get(urlAPI, headers)
        .then(response => {

            let arr = [];
            for (let pos=0; pos<response.data.length;pos++){
                arr.push(dataCapability(response.data[pos]));
            }

            if (onLoad){
                onLoad(arr);
            }

        })
        .catch(e => {
            if (onError){
                onError(e);
            }
        });


    return;

};



function dataCapability(data){

    let obj = data;

    return obj;

}

// ==== Participations ====

export const addParticipationToSolution = (dsd, idSolution, Data = {}, onAdd, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let payload = payloadParticipation(Data)

    dsd.httpConfig.post(`/solutions/${idSolution}/participations`, payload, headers)
        .then(response => {
            if (onAdd){
                onAdd(response.data._id)
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return;
}


export const editParticipation = (dsd, id = null, Data = {}, onUpdate, onError) => {


    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }


    let payload = payloadParticipation(Data)
    let idSolution = null;
    if (Data.Solution) {
        idSolution = Data.Solution._id;
    }

    dsd.httpConfig.put(`/solutions/${idSolution}/participations/${id}`, payload, headers)
        .then(response => {
            if (onUpdate){
                onUpdate();
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return true;
};

function payloadParticipation(inData){

    let data = cloneObject(inData)

    let payload = {}
    payload.name = data.name;
    payload.type = data.type;
    payload.description = data.description;
    payload.proposals = data.proposals;
    payload.status = data.status;
    payload.idCapability = data.idCapability;
    payload.idRole = data.idRole;

    return payload;

}

export const getParticipation = (dsd, id=null, onLoad=null, onFail=null, representation="dsd", format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/participations/${id}?`

        if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );

    return;

};


export const listParticipations = (dsd, Filters={}, onLoad, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }
    
    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let urlAPI = "/participations"
    if (Object.keys(Filters).length > 0){
        urlAPI += "?"
    }
    
    if (Filters.idUser){
        urlAPI += `idUser=${encodeURIComponent(Filters.idUser)}&`;
    }

    if (Filters.status){
        urlAPI += `status=${encodeURIComponent(Filters.status)}&`;
    }

    if (Filters.idSolution){
        urlAPI += `idSolution=${encodeURIComponent(Filters.idSolution)}&`;
    }

    if (Filters.idRole){
        urlAPI += `idRole=${encodeURIComponent(Filters.idRole)}&`;
    }

    if (Filters.idCapability){
        urlAPI += `idCapability=${encodeURIComponent(Filters.idCapability)}&`;
    }

    if (Filters.idNarrative){
        urlAPI += `idNarrative=${encodeURIComponent(Filters.idNarrative)}&`;
    }


    dsd.httpConfig.get(urlAPI, headers)
        .then(response => {

            let arr = [];
            for (let pos=0; pos<response.data.length;pos++){
                arr.push(dataParticipation(response.data[pos]));
            }

            if (onLoad){
                onLoad(arr);
            }

        })
        .catch(e => {
            if (onError){
                onError(e);
            }
        });

    return;

};



function dataParticipation(data){

    let obj = data;

    return obj;

}

export const assetsSolutionVersion = async function(dsd, idSolution, idVersion){

    const assets = {};

    let Promises = [];

    const listSystems = {};
    const listRoles = {};
    const listCapabilities = {};
    const listParticipations = {};

    let doc = null;
    let page = null;
    let index = null;
    let indexGDS = null;

    let site = null;
    let siteGDS = null;


    let xmi = null;
    let dot = null;
    let dotSystems = null;
    let dotRoles = null;
    let dotCapabilities = null;
    let dotParticipations = null;

    

    let svg = null;
    let svgSystems = null;
    let svgRoles = null;
    let svgCapabilities = null;
    let svgParticipations = null;

    let Solution = null


    const onDoneDoc = function(reply){
        doc = reply;
        return;
    };


    const onDonePage = function(reply){
        page = reply;
        return;
    };


    const onDoneIndex = function(reply){
        index = reply;
        return;
    };

    const onDoneIndexGDS = function(reply){
        indexGDS = reply;
        return;
    };


    const onDoneSite = function(reply){
        site = reply;
        return;
    };

    const onDoneSiteGDS = function(reply){
        siteGDS = reply;
        return;
    };



    const onDoneXmi = function(reply){
        xmi = reply;
        return;
    };

    const onDoneDot = function(reply){
        dot = reply;
        return;
    };

    const onDoneDotSystems = function(reply){
        dotSystems = reply;
        return;
    };

    const onDoneDotRoles = function(reply){
        dotRoles = reply;
        return;
    };

    const onDoneDotCapabilities = function(reply){
        dotCapabilities = reply;
        return;
    };

    const onDoneDotParticipations = function(reply){
        dotParticipations = reply;
        return;
    };


    const onDoneSvg = function(reply){
        svg = reply;
        return;
    };

    const onDoneSvgSystems = function(reply){
        svgSystems = reply;
        return;
    };

    const onDoneSvgRoles = function(reply){
        svgRoles = reply;
        return;
    };

    const onDoneSvgCapabilities = function(reply){
        svgCapabilities = reply;
        return;
    };

    const onDoneSvgParticipations = function(reply){
        svgParticipations = reply;
        return;
    };

    Promises.push(getSolutionVersion(dsd,idSolution,idVersion, onDoneDoc));
    
    Promises.push(getSolutionVersion(dsd,idSolution,idVersion, onDonePage, null,'page'));
    Promises.push(getSolutionVersion(dsd,idSolution,idVersion, onDoneIndex, null,'page', 'html'));

    Promises.push(getSolutionVersion(dsd,idSolution,idVersion, onDoneIndexGDS, null,'page', 'html',{style:'UK Government Design System'}));

    Promises.push(getSolutionVersion(dsd,idSolution,idVersion, onDoneSite, null,'site', 'json'));
    Promises.push(getSolutionVersion(dsd,idSolution,idVersion, onDoneSiteGDS, null,'site', 'json',{style:'UK Government Design System'}));

    Promises.push(getSolutionVersion(dsd,idSolution,idVersion, onDoneXmi, null,'xmi'));
    Promises.push(getSolutionVersion(dsd,idSolution,idVersion, onDoneDot, null,'dot'));
    Promises.push(getSolutionVersion(dsd,idSolution,idVersion, onDoneSvg, null,'image'));

    Promises.push(getSolutionVersionSystems(dsd,idSolution,idVersion, onDoneDotSystems, null,'dot'));
    Promises.push(getSolutionVersionRoles(dsd,idSolution,idVersion, onDoneDotRoles, null,'dot'));
    Promises.push(getSolutionVersionCapabilities(dsd,idSolution,idVersion, onDoneDotCapabilities, null,'dot'));
    Promises.push(getSolutionVersionParticipations(dsd,idSolution,idVersion, onDoneDotParticipations, null,'dot'));

    Promises.push(getSolutionVersionSystems(dsd,idSolution,idVersion, onDoneSvgSystems, null,'image'));
    Promises.push(getSolutionVersionRoles(dsd,idSolution,idVersion, onDoneSvgRoles, null,'image'));
    Promises.push(getSolutionVersionCapabilities(dsd,idSolution,idVersion, onDoneSvgCapabilities, null,'image'));
    Promises.push(getSolutionVersionParticipations(dsd,idSolution,idVersion, onDoneSvgParticipations, null,'image'));


    return(
        Promise.all(Promises)
        .then(async response => {

            if (doc){
                assets["dsd.json"] = doc;
                Solution = cloneObject(doc);

                for (const System of Solution.Systems){
                    listSystems[System._id] = System;
                }
                for (const Role of Solution.Roles){
                    listRoles[Role._id] = Role;
                }
                for (const Capability of Solution.Capabilities){
                    listCapabilities[Capability._id] = Capability;
                }
                for (const Participation of Solution.Participations){
                    listParticipations[Participation._id] = Participation;
                }


            }

            if (page){
                assets["page.md"] = page;
            }
            if (index){
                assets["index.html"] = index;
            }
            
            if (indexGDS){
                assets["indexGDS.html"] = indexGDS;
            }


            if (xmi){
                assets["solution.xmi"] = xmi;
            }
            if (dot){
                assets["dot.txt"] = dot;
            }

            if (svg){
                assets["image.svg"] = svg;
            }


            for (const idSystem in listSystems){
                const System = listSystems[idSystem];
                
                const strSystem = JSON.stringify(System,null,4);
                assets[`systems/${System._id}/dsd.json`] = strSystem;

                const dotSystem = dotSystems && dotSystems[System._id];
                if (dotSystem) assets[`systems/${System._id}/dot.txt`] = dotSystem;

                let svgSystem = svgSystems && svgSystems[System._id];
                if (svgSystem) assets[`systems/${System._id}/image.svg`] = svgSystem;

            }

            for (const idRole in listRoles){
                const Role = listRoles[idRole];
                
                const strRole = JSON.stringify(Role,null,4);
                assets[`roles/${Role._id}/dsd.json`] = strRole;

                const dotRole = dotRoles && dotRoles[Role._id];
                if (dotRole) assets[`roles/${Role._id}/dot.txt`] = dotRole;

                let svgRole = svgRoles && svgRoles[Role._id];
                if (svgRole) assets[`roles/${Role._id}/image.svg`] = svgRole;

            }
            for (const idCapability in listCapabilities){
                const Capability = listCapabilities[idCapability];
                
                const strCapability = JSON.stringify(Capability,null,4);
                assets[`capabilities/${Capability._id}/dsd.json`] = strCapability;

                const dotCapability = dotCapabilities && dotCapabilities[Capability._id];
                if (dotCapability) assets[`capabilities/${Capability._id}/dot.txt`] = dotCapability;

                let svgCapability = svgCapabilities && svgCapabilities[Capability._id];
                if (svgCapability) assets[`capabilities/${Capability._id}/image.svg`] = svgCapability;

            }
            for (const idParticipation in listParticipations){
                const Participation = listParticipations[idParticipation];
                
                const strParticipation = JSON.stringify(Participation,null,4);
                assets[`participations/${Participation._id}/dsd.json`] = strParticipation;

                const dotParticipation = dotParticipations && dotParticipations[Participation._id];
                if (dotParticipation) assets[`participations/${Participation._id}/dot.txt`] = dotParticipation;

                let svgParticipation = svgParticipations && svgParticipations[Participation._id];
                if (svgParticipation) assets[`participations/${Participation._id}/image.svg`] = svgParticipation;

            }


            if (site && Array.isArray(site.files)){
                for (const file of site.files){
                    if (file.content != null){
                        assets[`site/${file.path}`] = file.content;
                    }
                }
            }

            if (siteGDS && Array.isArray(siteGDS.files)){
                for (const file of siteGDS.files){
                    if (file.content != null){
                        assets[`siteGDS/${file.path}`] = file.content;
                    }
                }
            }

            return assets;    

        })
    )

};


export const zipSolution = async function(dsd, id, idVersion){

    const zip = new JSZip();

    const assets = await assetsSolutionVersion(dsd, id, idVersion);

    const Solution = assets["dsd.json"];

    let nameFolder = `solution_${id}`;
    if (idVersion){
        nameFolder += `_version_${idVersion}`;
    }

    for (const idAsset in assets){
        let assetValue = assets[idAsset];

        // Serialize JSON-like objects before zipping.
        if (
            typeof assetValue === 'object' &&
            assetValue !== null &&
            !(assetValue instanceof Blob) &&
            !(assetValue instanceof ArrayBuffer) &&
            !(assetValue instanceof Uint8Array)
        ) {
            assetValue = JSON.stringify(assetValue, null, 4);
        }

        zip.file(`${nameFolder}/${idAsset}`, assetValue);

// repeat for /site and /siteGDS

        if (idAsset.startsWith("site/") || idAsset.startsWith("siteGDS/")) {
            continue;
        }

        switch (idAsset) {
            case "page.md":
            case "index.html":
            case "indexGDS.html":
                break; // Skip these files for /site and /siteGDS
            default:{
                zip.file(`${nameFolder}/site/${idAsset}`, assetValue);
                zip.file(`${nameFolder}/siteGDS/${idAsset}`, assetValue);
            }
        }
    }

    const zipData = await zip.generateAsync({
        type: "blob",
        streamFiles: true,
    });

    return zipData;

};


/*
export const zipSolution = async function(dsd, Solution){

    const zip = new JSZip();

    let Promises = [];

    let Version = null;
    let idVersion = null;
    if (Solution.Version){
        Version = Solution.Version;
        idVersion = Version._id;
    }

    let nameFolder = `solution_${Solution._id}`;
    if (Version){
        nameFolder += `_version_${idVersion}`;
    }

    let strSolution = JSON.stringify(Solution, null, 4);
    zip.file(`${nameFolder}/dsd.json`, strSolution);

    let page = null;
    let index = null;
    let indexGDS = null;
    let site = null;
    let siteGDS = null;
    let xmi = null;
    let dot = null;
    let dotRoles = null;
    let dotCapabilities = null;
    let dotSystems = null;
    let dotParticipations = null;

    let svg = null;
    let svgRoles = null;
    let svgCapabilities = null;
    let svgSystems = null;
    let svgParticipations = null;


    const onDonePage = function(reply){
        page = reply;
        return;
    };

    const onDoneIndex = function(reply){
        index = reply;
        return;
    };

    const onDoneIndexGDS = function(reply){
        indexGDS = reply;
        return;
    };


    const onDoneSite = function(reply){
        site = reply;
        return;
    };

    const onDoneSiteGDS = function(reply){
        siteGDS = reply;
        return;
    };


    const onDoneXmi = function(reply){
        xmi = reply;
        return;
    };

    const onDoneDot = function(reply){
        dot = reply;
        return;
    };

    const onDoneDotRoles = function(reply){
        dotRoles = reply;
        return;
    };
    const onDoneDotCapabilities = function(reply){
        dotCapabilities = reply;
        return;
    };
    const onDoneDotSystems = function(reply){
        dotSystems = reply;
        return;
    };
    const onDoneDotParticipations = function(reply){
        dotParticipations  = reply;
        return;
    };


    const onDoneSvg = function(reply){
        svg = reply;
        return;
    };

    const onDoneSvgRoles = function(reply){
        svgRoles = reply;
        return;
    };
    const onDoneSvgCapabilities = function(reply){
        svgCapabilities = reply;
        return;
    };
    const onDoneSvgSystems = function(reply){
        svgSystems = reply;
        return;
    };
    const onDoneSvgParticipations = function(reply){
        svgParticipations  = reply;
        return;
    };


    Promises.push(getSolutionVersion(dsd,Solution._id,idVersion, onDonePage, null,'page'));

    Promises.push(getSolutionVersion(dsd,Solution._id,idVersion, onDoneIndex, null,'page', 'html'));
    Promises.push(getSolutionVersion(dsd,Solution._id,idVersion, onDoneIndexGDS, null,'page', 'html',{style:'UK Government Design System'}));

    Promises.push(getSolutionVersion(dsd,Solution._id,idVersion, onDoneSite, null,'site', 'json'));
    Promises.push(getSolutionVersion(dsd,Solution._id,idVersion, onDoneSiteGDS, null,'site', 'json',{style:'UK Government Design System'}));

    
    Promises.push(getSolutionVersion(dsd,Solution._id,idVersion, onDoneXmi, null,'xmi'));
    Promises.push(getSolutionVersion(dsd,Solution._id,idVersion, onDoneDot, null,'dot'));
    Promises.push(getSolutionVersionRoles(dsd,Solution._id,idVersion, onDoneDotRoles, null,'dot'));
    Promises.push(getSolutionVersionCapabilities(dsd,Solution._id,idVersion, onDoneDotCapabilities, null,'dot'));
    Promises.push(getSolutionVersionSystems(dsd,Solution._id,idVersion, onDoneDotSystems, null,'dot'));
    Promises.push(getSolutionVersionParticipations(dsd,Solution._id,idVersion, onDoneDotParticipations, null,'dot'));

    Promises.push(getSolutionVersion(dsd,Solution._id,idVersion, onDoneSvg, null,'image'));
    Promises.push(getSolutionVersionRoles(dsd,Solution._id,idVersion, onDoneSvgRoles, null,'image'));
    Promises.push(getSolutionVersionCapabilities(dsd,Solution._id,idVersion, onDoneSvgCapabilities, null,'image'));
    Promises.push(getSolutionVersionSystems(dsd,Solution._id,idVersion, onDoneSvgSystems, null,'image'));
    Promises.push(getSolutionVersionParticipations(dsd,Solution._id,idVersion, onDoneSvgParticipations, null,'image'));



    return(
        Promise.all(Promises)
        .then(async response => {
            if (page){
                zip.file(`${nameFolder}/page.md`, page);
            }

            if (index){
                zip.file(`${nameFolder}/index.html`, index);
            }

            if (indexGDS){
                zip.file(`${nameFolder}/indexGDS.html`, indexGDS);
            }

            if (xmi){
                zip.file(`${nameFolder}/solution.xmi`, xmi);
            }
            if (dot){
                zip.file(`${nameFolder}/dot.txt`,dot);
            }
            if (svg){
                zip.file(`${nameFolder}/image.svg`,svg);
            }

            let listRoles = {};
            for (let pos=0; pos<Solution.Roles.length; pos++){
                let Role = cloneObject(Solution.Roles[pos]);

                if (Role.status === 'deprecated'){
                    continue
                }

                Role.Solution = cloneObject(Solution);
                delete Role.Solution.Roles;
                delete Role.Solution.Capabilities;
                delete Role.Solution.Systems;
                delete Role.Solution.Participations;

                listRoles[Role._id] = Role;

                let dotRole = dotRoles && dotRoles[Role._id];
                if (dotRole) zip.file(`${nameFolder}/roles/${Role._id}/dot.txt`, dotRole);

                let svgRole = svgRoles && svgRoles[Role._id];
                if (svgRole) zip.file(`${nameFolder}/roles/${Role._id}/image.svg`, svgRole);

            }

            for (let idRole in listRoles){
                let Role = listRoles[idRole];
                
                let strRole = JSON.stringify(Role,null,4);
                zip.file(`${nameFolder}/roles/${Role._id}/dsd.json`, strRole);
            }

            let listCapabilities = {};
            for (let pos=0; pos<Solution.Capabilities.length; pos++){
                let Capability = cloneObject(Solution.Capabilities[pos]);

                if (Capability.status === 'deprecated'){
                    continue
                }

                Capability.Solution = cloneObject(Solution);
                delete Capability.Solution.Roles;
                delete Capability.Solution.Capabilities;
                delete Capability.Solution.Systems;
                delete Capability.Solution.Participations;

                listCapabilities[Capability._id] = Capability;

                let dotCapability = dotCapabilities && dotCapabilities[Capability._id];
                if (dotCapability) zip.file(`${nameFolder}/capabilities/${Capability._id}/dot.txt`, dotCapability);

                let svgCapability = svgCapabilities && svgCapabilities[Capability._id];
                if (svgCapability) zip.file(`${nameFolder}/capabilities/${Capability._id}/image.svg`, svgCapability);

            }

            for (let idCapability in listCapabilities){
                let Capability = listCapabilities[idCapability];
                
                let strCapability = JSON.stringify(Capability,null,4);
                zip.file(`${nameFolder}/capabilities/${Capability._id}/dsd.json`, strCapability);
            }

            let listSystems = {};
            for (let pos=0; pos<Solution.Systems.length; pos++){
                let System = cloneObject(Solution.Systems[pos]);

                if (System.status === 'deprecated'){
                    continue
                }

                System.Solution = cloneObject(Solution);
                delete System.Solution.Roles;
                delete System.Solution.Capabilities;
                delete System.Solution.Systems;
                delete System.Solution.Participations;

                listSystems[System._id] = System;

                let dotSystem = dotSystems && dotSystems[System._id];
                if (dotSystem) zip.file(`${nameFolder}/systems/${System._id}/dot.txt`, dotSystem);

                let svgSystem = svgSystems && svgSystems[System._id];
                if (svgSystem) zip.file(`${nameFolder}/systems/${System._id}/image.svg`, svgSystem);

            }

            for (let idSystem in listSystems){
                let System = listSystems[idSystem];
                
                let strSystem = JSON.stringify(System,null,4);
                zip.file(`${nameFolder}/systems/${System._id}/dsd.json`, strSystem);
            }

            let listParticipations = {};
            for (let pos=0; pos<Solution.Participations.length; pos++){
                let Participation = cloneObject(Solution.Participations[pos]);

                if (Participation.status === 'deprecated'){
                    continue
                }

                Participation.Solution = cloneObject(Solution);
                delete Participation.Solution.Roles;
                delete Participation.Solution.Capabilities;
                delete Participation.Solution.Systems;
                delete Participation.Solution.Participations;

                listParticipations[Participation._id] = Participation;

                let dotParticipation = dotParticipations && dotParticipations[Participation._id];
                if (dotParticipation) zip.file(`${nameFolder}/participations/${Participation._id}/dot.txt`, dotParticipation);

                let svgParticipation = svgParticipations && svgParticipations[Participation._id];
                if (svgParticipation) zip.file(`${nameFolder}/participations/${Participation._id}/image.svg`, svgParticipation);

            }

            for (let idParticipation in listParticipations){
                let Participation = listParticipations[idParticipation];
                
                let strParticipation = JSON.stringify(Participation,null,4);
                zip.file(`${nameFolder}/participations/${Participation._id}/dsd.json`, strParticipation);
            }

            if (site && Array.isArray(site.files)){
                for (const file of site.files){
                    if (file.content != null){
                        zip.file(`${nameFolder}/site/${file.path}`, file.content);
                    }
                }

                zip.file(`${nameFolder}/site/dsd.json`, strSolution);

                if (xmi){
                    zip.file(`${nameFolder}/site/solution.xmi`, xmi);
                }
                if (dot){
                    zip.file(`${nameFolder}/site/dot.txt`,dot);
                }


                if (svg){
                    zip.file(`${nameFolder}/site/image.svg`,svg);
                }

                for (let idSystem in listSystems){
                    let svgSystem = svgSystems && svgSystems[idSystem];
                    if (svgSystem) zip.file(`${nameFolder}/site/systems/${idSystem}/image.svg`, svgSystem);
                }

                for (let idRole in listRoles){
                    let svgRole = svgRoles && svgRoles[idRole];
                    if (svgRole) zip.file(`${nameFolder}/site/roles/${idRole}/image.svg`, svgRole);
                }

                for (let idCapability in listCapabilities){
                    let svgCapability = svgCapabilities && svgCapabilities[idCapability];
                    if (svgCapability) zip.file(`${nameFolder}/site/capabilities/${idCapability}/image.svg`, svgCapability);
                }

                for (let idParticipation in listParticipations){
                    let svgParticipation = svgParticipations && svgParticipations[idParticipation];
                    if (svgParticipation) zip.file(`${nameFolder}/site/participations/${idParticipation}/image.svg`, svgParticipation);
                }

            }

            if (siteGDS && Array.isArray(siteGDS.files)){
                for (const file of siteGDS.files){
                    if (file.content != null){
                        zip.file(`${nameFolder}/siteGDS/${file.path}`, file.content);
                    }
                }

                zip.file(`${nameFolder}/siteGDS/dsd.json`, strSolution);


                if (xmi){
                    zip.file(`${nameFolder}/siteGDS/solution.xmi`, xmi);
                }
                if (dot){
                    zip.file(`${nameFolder}/siteGDS/dot.txt`,dot);
                }

                if (svg){
                    zip.file(`${nameFolder}/siteGDS/image.svg`,svg);
                }

                for (let idSystem in listSystems){
                    let svgSystem = svgSystems && svgSystems[idSystem];
                    if (svgSystem) zip.file(`${nameFolder}/siteGDS/systems/${idSystem}/image.svg`, svgSystem);
                }

                for (let idRole in listRoles){
                    let svgRole = svgRoles && svgRoles[idRole];
                    if (svgRole) zip.file(`${nameFolder}/siteGDS/roles/${idRole}/image.svg`, svgRole);
                }

                for (let idCapability in listCapabilities){
                    let svgCapability = svgCapabilities && svgCapabilities[idCapability];
                    if (svgCapability) zip.file(`${nameFolder}/siteGDS/capabilities/${idCapability}/image.svg`, svgCapability);
                }

                for (let idParticipation in listParticipations){
                    let svgParticipation = svgParticipations && svgParticipations[idParticipation];
                    if (svgParticipation) zip.file(`${nameFolder}/siteGDS/participations/${idParticipation}/image.svg`, svgParticipation);
                }

            }


            const zipData = await zip.generateAsync({
                type: "blob",
                streamFiles: true,
            })
        
            return zipData;    

        })
    )

};

*/